"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallScriptAcquisitionWorker = void 0;
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
const os = require("os");
const path = require("path");
const EventStreamEvents_1 = require("../EventStream/EventStreamEvents");
const FileUtilities_1 = require("../Utils/FileUtilities");
const InstallIdUtilities_1 = require("../Utils/InstallIdUtilities");
const WebRequestWorkerSingleton_1 = require("../Utils/WebRequestWorkerSingleton");
class InstallScriptAcquisitionWorker {
    constructor(context) {
        this.context = context;
        this.scriptAcquisitionUrl = 'https://builds.dotnet.microsoft.com/dotnet/scripts/v1/dotnet-install.';
        this.scriptFileEnding = os.platform() === 'win32' ? 'ps1' : 'sh';
        this.scriptFileName = 'dotnet-install';
        this.scriptFilePath = path.join(__dirname, 'install scripts', `${this.scriptFileName}.${this.scriptFileEnding}`);
        this.webWorker = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance();
        this.fileUtilities = new FileUtilities_1.FileUtilities();
    }
    getFallbackScript() {
        return __awaiter(this, void 0, void 0, function* () {
            const fallbackPath = this.getFallbackScriptPath();
            if ((yield this.fileUtilities.exists(fallbackPath))) {
                this.context.eventStream.post(new EventStreamEvents_1.DotnetFallbackInstallScriptUsed());
                return fallbackPath;
            }
            throw new EventStreamEvents_1.EventBasedError('UnableToAcquireDotnetInstallScript', `Failed to Find Dotnet Install Script: ${this.scriptFileName}.${this.scriptFileEnding}. Please download .NET Manually.`);
        });
    }
    getDotnetInstallScriptPath() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const script = yield this.webWorker.getCachedData(`${this.scriptAcquisitionUrl}${this.scriptFileEnding}`, this.context);
                if (!script) {
                    return this.getFallbackScript();
                }
                yield this.fileUtilities.writeFileOntoDisk(script, this.scriptFilePath, this.context.eventStream);
                this.context.eventStream.post(new EventStreamEvents_1.DotnetInstallScriptAcquisitionCompleted());
                return this.scriptFilePath;
            }
            catch (error) {
                this.context.eventStream.post(new EventStreamEvents_1.DotnetInstallScriptAcquisitionError(error, (0, InstallIdUtilities_1.getInstallFromContext)(this.context)));
                return this.getFallbackScript();
            }
        });
    }
    getFallbackScriptPath() {
        return this.scriptFilePath;
    }
}
exports.InstallScriptAcquisitionWorker = InstallScriptAcquisitionWorker;
//# sourceMappingURL=InstallScriptAcquisitionWorker.js.map